import App from "./App";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "./style/globals.less";
import { Provider } from "mobx-react";
import stores from "./stores";
dayjs.locale("zh-cn");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <div className="microfront-root">
    <BrowserRouter>
      <Provider {...stores}>
        <App />
      </Provider>
    </BrowserRouter>
  </div>
);
reportWebVitals();
